import * as React from "react";
import { BsClock, BsLockFill, BsCheckCircle } from "react-icons/bs";
import PicksHelper from "common/picksHelper";
import { useForceUpdate } from "common/helpers/componentHelper";
import { useEffect } from "react";

export default function Timer(props) {
	const forceUpdate = useForceUpdate();
	const picksHelper = new PicksHelper(props.eventData);
	const locked = picksHelper.isLocked();
	const finished = picksHelper.isFinished();
	const lockTime = picksHelper.getTimeTillLock();

	/** Tick each second so the countdown stays live. */
	useEffect(() => {
		if (!locked) {
			const timer = window.setTimeout(() => {
				forceUpdate();
			}, 1000);

			return () => {
				if (timer) {
					window.clearTimeout(timer);
				}
			};
		}
	});

	if (!props.eventData) {
		return <></>;
	}

	const stateClass = finished ? "done" : locked ? "locked" : "";

	return (
		<div className={"pane-strip " + stateClass}>
			{finished && (
				<span className="strip-label">
					<BsCheckCircle />
					Event complete
				</span>
			)}
			{!finished && locked && (
				<span className="strip-label">
					<BsLockFill />
					Picks are locked
				</span>
			)}
			{!finished && !locked && (
				<>
					<span className="strip-label">
						<BsClock />
						Picks lock in
					</span>
					<span className="strip-value">{lockTime}</span>
				</>
			)}
		</div>
	);
}
